import { gql } from "@apollo/client";

export const SET_PASSWORD = gql`
  mutation setPassword($input: SetPasswordInput!) {
    setPassword(input: $input) {
      clientMutationId
      errors
    }
  }
`;

// Example input
// {
//   "input": {
//    "originatorId": "1243"
//    "password": "Password123",
//   }
// }
